import React, { useEffect, useState } from "react";
import { List, message, Typography } from "antd";
import CustomDrawer from "components/shared-components/CustomDrawer";
import { CloseOutlined, UnorderedListOutlined } from "@ant-design/icons";
const { Text } = Typography;
const styles = {
  chatBackground: {
    // backgroundImage: `url(https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png)`,
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    // borderRadius: '8px',
    // padding: '16px',
    // height:'100%'
  },
  chatBubble: {
    background: "white",
    borderRadius: "8px",
    padding: "16px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    position: "relative",
    width: "100%",
    wordWrap: "break-word",
  },
  buttoneBubble: {
    background: "white",
    borderRadius: "8px",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,

    // padding: '16px',
    boxShadow: "0 8px 8px -4px rgba(0, 0, 0, 0.15)",
    position: "relative",
    bottom: "0.5rem",
    width: "100%",
    wordWrap: "break-word",
  },
  chatBubbleBefore: {
    content: '""',
    position: "absolute",
    top: "0",
    right: "-5px", // Changed from left: "-5px" to right: "-5px"
    width: "0",
    height: "0",
    borderStyle: "solid",
    borderWidth: "10px 0 10px 10px", // Changed from "10px 10px 10px 0" to "10px 0 10px 10px"
    borderColor: "transparent transparent transparent white", // Changed from "transparent white transparent transparent"
    background: "#ffff",
    backgroundColor: "#ffff",
    clipPath: "polygon(0 0, 100% 0, 0 100%)", // Changed from "polygon(0 0, 0 100%, 100% 100%)"
    transform: "none", // Removed rotation since we're flipping the shape horizontally
  },
  chatTime: {
    textAlign: "right",
    fontSize: "12px",
    color: "gray",
    marginTop: "8px",
  },
  footerMessageStyle: {
    fontSize: "12px",
    marginTop: "5px",
    color: "#918f8f",
  },
  buttonStyle: {
    // fontSize: '11px',
    wordWrap: "break-word",
    fontFamily: "system-ui",
    display: "block",
    textAlign: "justify",
  },
  listItem: {
    padding: "12px 0", // Add vertical padding
    borderBottom: "1px solid #f0f0f0", // Ant Design's default border color
  },
  text: {
    margin: 0, // Reset any default margins
  },
};
const RanderListItemPreview = ({ presets, text, presetName }) => {
  const [previewData, setPreviewData] = useState({});
  const [showOption, setShowOptions] = useState(false);
  useEffect(() => {
    const lookupName = presetName || text;
    let data = presets?.find((item) => item?.name === lookupName);
    if (!data && text) {
      data = presets?.find(
        (item) =>
          item?.header === text ||
          item?.body === text ||
          (item?.body && text && item.body.includes(text))
      );
    }
    setPreviewData(data || {});
  }, [text, presetName, presets]);
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = '.ant-drawer-mask { display: none !important; }';
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const HandleDrawer = () => {
    const filteredRows = JSON.parse(previewData?.rows)?.filter(
      (row) => row?.id.trim() !== "" || row?.label?.trim() !== ""
    );
    if (filteredRows?.length > 0 && previewData?.body) {
      setShowOptions(true);
    } else {
      message.error(
        "Atleast One Option Is Required To Show Drawer And Body Text Is Required"
      );
    }
  };
  return (
    <div className="d-flex align-items-center justify-content-center flex-column chat-preview-container" style={{maxWidth:'20rem', width: '100%'}}>
      <div style={styles.chatBubble}>
        <div style={styles.chatBubbleBefore}></div>
        <div className="header">
          <h5>{previewData?.header}</h5>
        </div>
        {previewData?.body && (
          <>
            <div>
              {previewData?.body.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line.split(/\*([^*]+)\*/g).map((part, index) => {
                    if (index % 2 === 1) {
                      return (
                        <Text key={index} style={{ fontWeight: "bold" }}>
                          {part}
                        </Text>
                      );
                    } else {
                      return <Text key={index}>{part}</Text>;
                    }
                  })}
                  <br />
                </React.Fragment>
              ))}
            </div>
            <br />
          </>
        )}
        <span style={styles.footerMessageStyle}>{previewData?.footer}</span>
      </div>
      <div style={styles.buttoneBubble}>
        <span
          style={styles.buttonStyle}
          className="border-top py-2 cursor-pointer"
        >
          <button
            className="border-0 bg-transparent fw-bold w-100 cursor-pointer"
            style={{ color: "#34B7F1" }}
            onClick={() => HandleDrawer()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <UnorderedListOutlined />
              {previewData?.button_text}
            </div>
          </button>
        </span>
      </div>
      <div>
        <CustomDrawer
          title={previewData?.button_text}
          onClose={() => setShowOptions(false)}
          placement="bottom"
          open={showOption}
          closable={true}
          height={220}
          rootStyle={{ position: "absolute", width: "94%", left: 22 }}
          style={{ position: "absolute" }}
          getContainer={false}
          closeIcon={<CloseOutlined />}
        >
          <List>
            {previewData?.rows &&
              JSON.parse(previewData?.rows)?.map((item, index) => (
                <List.Item key={index} style={styles.listItem} className="py-3">
                  <Typography.Text
                    className="h5 text-black"
                    style={styles.text}
                  >
                    {item?.label}
                  </Typography.Text>
                </List.Item>
              ))}
          </List>
        </CustomDrawer>
      </div>
    </div>
  );
};

export default RanderListItemPreview;
